import { Tooltip } from '@chakra-ui/react'
import React from 'react'

type ImageAndValueProps = {
  value: string
  iconUrl?: string
  tooltip?: boolean
}

const ImageAndValue: React.FC<ImageAndValueProps> = ({
  value,
  iconUrl,
  tooltip,
}) => {
  const content = (
    <div className="flex items-center gap-2">
      {iconUrl && (
        <img src={iconUrl} alt={value} className="w-5 h-5 rounded-full" />
      )}
      <p className="font-normal whitespace-nowrap">{value}</p>
    </div>
  )

  if (tooltip) {
    return (
      <Tooltip label={value} placement="top">
        {content}
      </Tooltip>
    )
  }

  return content
}

export default ImageAndValue
